var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"iframe-login-dialog",attrs:{"visible":_vm.dialogVisible,"width":"100vw","destroy-on-close":true},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"iframeBox"})])
}
var staticRenderFns = []

export { render, staticRenderFns }